import { createRoutine } from 'redux-saga-routines';
import {
  GET_COUNTRIES,
  GET_PERFORMANCES_NUMBER,
  GET_ARTISTS_NUMBER,
  THIRD_PARTY_APP_LOGIN,
  GET_REGIONS,
  REMOTE_LOGOUT_USER,
  SET_IS_LOGGED_IN,
  SET_TOKEN_LOGIN_LOADING,
  GET_USER_CONSTANTS,
} from './consts';

export const getCountriesAction = createRoutine(GET_COUNTRIES);
export const getRegionsAction = createRoutine(GET_REGIONS);
export const tokenLoginAction = createRoutine(THIRD_PARTY_APP_LOGIN);
export const getPerformancesNumberAction = createRoutine(GET_PERFORMANCES_NUMBER);
export const getArtistsNumberAction = createRoutine(GET_ARTISTS_NUMBER);
export const remoteLogoutAction = createRoutine(REMOTE_LOGOUT_USER);
export const setIsLoggedInAction = createRoutine(SET_IS_LOGGED_IN);
export const tokenLoginLoadingnAction = createRoutine(SET_TOKEN_LOGIN_LOADING);
export const getUserConstants = createRoutine(GET_USER_CONSTANTS);
